import { applyMiddleware, createStore, compose } from "redux";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import thunk from "redux-thunk";
import initialState from "./initialState";
import mergeDeep from "../util/mergeDeep";
import rootReducer from "../reducers/rootReducer";
let store;

function configureStore(initialState) {
	if (process.env.NODE_ENV === 'production') {
		store = createStore(
			rootReducer,
			initialState,
			applyMiddleware(thunk)
		);
	} else {
		const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
		store = createStore(
			rootReducer,
			initialState,
			composeEnhancers(applyMiddleware(thunk, reduxImmutableStateInvariant()))
		);
	}
	return store;
}

export function getStore() {
	if (!store)
		store = configureStore(initialState);

	return store;
}

export function getState() {
	return getStore().getState();
}

export function getLayout() {
	return mergeDeep({}, getState().layout);
}

export function getSession() {
	return getState().session;
}

export function getSettings() {
	return getState().settings;
}

export function getApiRoot() {
	return getSettings().apiRoot;
}

export function getSubsidiesWebAppRoot() {
	return getSettings().subsidiesWebAppRoot;
}